import useWorkspace from '@app/features/Workspace/store/hooks/useWorkspace';
import { getResourceURL } from '@app/shared/helpers/share';
import { showNotification } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { Resource } from '@app/types/blackroom-api';

export function useCopyShareLink() {
  const { t } = useTranslation(['Common', 'Resource']);
  const workspace = useWorkspace();

  return {
    copyShareLink(resource: Pick<Resource, 'id' | 'type'>) {
      const resourceURL = getResourceURL(resource, workspace);
      navigator.clipboard.writeText(resourceURL);
      showNotification({
        title: t('Resource:Common.notifications.shareLinkCopiedTitle'),
        message: t('Resource:Common.notifications.shareLinkCopiedMessage'),
        color: 'blackroomGreen',
      });
    },
  };
}
